import React from 'react';
import { Icon } from '@iconify/react';
import { Droppable } from '@hello-pangea/dnd';
import KanbanCardV2 from './KanbanCardV2';
import styles from './afterpay.module.scss';

// KAN-01: Tooltips explicativos por coluna (spec v2.1)
// Cada texto explica: o que a coluna representa + ação esperada do Rep Logística.
const COLUMN_TOOLTIPS = {
  // Aba Geral
  reportados: 'Pedidos com problemas no cadastro (CPF/CEP inválido, endereço incompleto). Próxima ação: corrigir os dados ou reportar.',
  expedicao: 'Pedidos pagos que ainda não têm código de rastreio — aguardando cadastro pra seguir pra expedição.',
  enviados: 'Pedidos com código de rastreio cadastrado, aguardando movimentação dos Correios.',
  saiu_entrega: 'Pedidos a caminho do destinatário (status "saiu para entrega" nos Correios).',
  retirar_correios: 'Pedidos disponíveis para retirada na agência dos Correios. Contagem regressiva no card.',
  requer_atencao: 'Pedidos com tentativa de entrega falhada, 3+ dias aguardando retirada, ou marcação manual. Priorize: 1=urgente, 2=médio, 3=baixo.',
  entregue: 'Pedidos entregues nos últimos 4 dias, aguardando confirmação de pagamento (AfterPay).',
  inadimplencia: 'Pedidos entregues há 5-9 dias sem pagamento confirmado. Considere contato com o cliente.',
  frustrados: 'Pedidos entregues há 10+ dias sem pagamento. Casos perdidos — análise individual.',
  pagos: 'Pedidos entregues E com pagamento confirmado. Ciclo fechado.',
  // Aba Frustrações
  frustracoes: 'Pagamentos frustrados — cliente recebeu mas não pagou após o prazo.',
  roubos: 'Roubos e extravios reportados pelo cliente ou pelos Correios.',
  retornado: 'Pedidos que voltaram ao remetente sem entrega.',
  'devolvidos-reverso': 'Logística reversa — produto devolvido pelo cliente após entrega.',
  'cancelado-sem-custo': 'Pedidos cancelados antes do envio (automático ou manual via "Cancelar envio").',
  pending_requests: 'Solicitações operacionais pendentes — cancelamento, logística reversa e outras demandas feitas pela plataforma.',
};

const KanbanColumn = ({ column, isFirstColumn = false, index, enableDrag = true, isFullscreen = false, onCardClick, onManageTags, onCancelShipment, onReport }) => {


  // Mapear ID da coluna para classe CSS
  const getColumnClass = (columnId) => {
    const classMap = {
      // Colunas do AfterPay Geral
      'reportados': 'reportados',
      'expedicao': 'expedicao', 
      'enviados': 'enviados',
      'saiu_entrega': 'saiuEntrega',
      'retirar_correios': 'retirarCorreios',
      'requer_atencao': 'requerAtencao',
      'entregue': 'entregue',
      'inadimplencia': 'inadimplencia',
      'frustrados': 'frustrados',
      'pagos': 'pagos',
      // Colunas de Frustração
      'frustracoes': 'frustracoes',
      'roubos': 'roubos',
      'devolvidos-reverso': 'devolvidos-reverso',
      'retornado': 'retornado',
      'cancelado-sem-custo': 'cancelado-sem-custo',
      // KAN-09 / Pacote 5: Solicitações Pendentes
      'pending_requests': 'pending_requests'
    };
    const className = classMap[columnId] || '';
    return className;
  };

  const tooltip = COLUMN_TOOLTIPS[column.id] || null;

  return (
    <div className={`kanban-column ${getColumnClass(column.id)}`}>
      <div
        className={`kanban-column-header ${getColumnClass(column.id)}`}
        title={tooltip || undefined}
      >
        <div className={styles.kanbanColumnTitle}>
          <Icon icon={column.icon} />
          <span>{column.title}</span>
          {tooltip && (
            <Icon
              icon="mdi:information-outline"
              width="13"
              style={{ marginLeft: 4, opacity: 0.55, cursor: 'help' }}
            />
          )}
        </div>
        <span
          className={`${styles.kanbanColumnCount} badge ${getColumnClass(column.id)}`}
        >
          {column.cards.length}
        </span>
      </div>
      {enableDrag ? (
        <Droppable droppableId={String(column.id)}>
          {(provided, snapshot) => (
            <div
              className={styles.kanbanColumnBody}
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ 
                marginRight: '1px',
                scrollbarWidth: 'thin',
                scrollbarColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6B7280 transparent' : 'var(--scrollbar-thumb) transparent'
              }}
            >
              {column.cards.map((card, cardIndex) => (
                <KanbanCardV2
                  key={String(card.id)}
                  card={card}
                  index={cardIndex}
                  enableDrag={true}
                  onCardClick={onCardClick}
                  onManageTags={onManageTags}
                  onCancelShipment={onCancelShipment}
                  onReport={onReport}
                  columnId={column.id}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        ) : (
          <div 
            className={styles.kanbanColumnBody} 
            style={{ 
              marginRight: '1px',
              scrollbarWidth: 'thin',
              scrollbarColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#0680F9 transparent' : 'var(--scrollbar-thumb) transparent'
            }}
          >
          {column.cards.map((card, cardIndex) => (
            <KanbanCardV2
              key={card.id}
              card={card}
              index={cardIndex}
              enableDrag={false}
              onCardClick={onCardClick}
              onManageTags={onManageTags}
              onCancelShipment={onCancelShipment}
              onReport={onReport}
              columnId={column.id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default KanbanColumn; 